import { getCalendarOptions } from 'owa-calendar-processing-configuration';
import getForwardMeetingNotificationOption from '../selectors/getForwardMeetingNotificationOption';
import getOldMeetingMessgeOption from '../selectors/getOldMeetingMessageOption';
/**
 * Returns true if there is a change in the event options
 */
export default function isInvitationOptionDirty() {
    var calendarProcessingConfiguration = getCalendarOptions();
    if (!calendarProcessingConfiguration) {
        return false;
    }
    var oldMeetingMessagesStatus = getOldMeetingMessgeOption();
    var forwardedMeetingNotificationsStatus = getForwardMeetingNotificationOption();
    return (oldMeetingMessagesStatus !== calendarProcessingConfiguration.RemoveOldMeetingMessages ||
        forwardedMeetingNotificationsStatus !==
            calendarProcessingConfiguration.RemoveForwardedMeetingNotifications);
}
//# sourceMappingURL=isInvitationOptionDirty.js.map